module.exports = __webpack_public_path__ + "img/decline-logo.103fd7bc.png";